import { Route, Routes, useMatch } from "react-router-dom"
import Footer from "./components/Footer"
import Header from "./components/Header"
import Wrapper from "./components/Wrapper"
import AdminPage from "./pages/AdminPage"
import EventPage from "./pages/EventPage"
import HomePage from "./pages/HomePage"
import './sass/style.sass'

function App() {

  return (
    <Routes>
      <Route path="/showroom/" element={<Wrapper />} >
        <Route index element={<HomePage />} />
        <Route path="event/:id" element={<EventPage />} />
      </Route>
      <Route path="/showroom/admin/*" element={<AdminPage />} />
    </Routes>
  )
}

export default App
